<div *ngIf="!_lummy.loaded" class="flex" style="height: 100%;width: 100%;justify-content: center;align-items: center;flex-direction: column;">
  <div style="margin-top: -10vh;">
    <ng-lottie [options]="animationLoading"  width="10vw" height="12vh" />
  </div>
  <div>
    Sincronizando dados
  </div>
</div>
<div class="flex flex-column h-full" style="overflow: hidden;" *ngIf="_lummy.loaded">
    <div class="flex align-items-center border-bottom-1 surface-border p-3 lg:p-2">
        <div class="relative flex align-items-center mr-3">
            <img src="assets/logotipo.png" alt="user.name" class="w-4rem h-4rem border-circle shadow-4">

        </div>
        <div class="mr-2">
            <span class="text-900 font-semibold block">Lumy</span>
            <span class="text-700">Online</span>
        </div>
        <!-- <div class="flex align-items-center ml-auto" >
            <button pButton pRipple type="button" icon="pi pi-ellipsis-v" class="p-button-rounded p-button-outlined p-button-secondary" style="border: none;"></button>
        </div> -->
    </div>
    <div style="height: 100%;">
        <div [ngClass]="{'tema-claro': tema === 'light', 'tema-escuro': tema !== 'light'}"
        class="p-3 md:px-4 lg:px-6 lg:py-4 overflow-y-auto"
        style="height: 60vh; "
        #chatWindow
        [scrollTop]="chatWindow.scrollHeight">


            <div *ngFor="let message of user.messages; let last = last" >
                <div *ngIf="message.ownerId !== 1">
                    <img src="assets/logotipo.png" alt="user.name" style="width: 20px;">
                    <div  class="grid grid-nogutter mb-4">
                        <div class="col mt-3"  >
                            <span class=" inline-block font-medium border-1 surface-border p-3 white-space-normal border-round"
                            style="word-break: break-word; max-width:80%; background-color: white; color: black;"
                            [innerHTML]="message.text">
                            <!-- {{}} -->
                            <br>
                            </span>
                            <p class="text-700 mt-3" >{{parseDate(message.createdAt)}}<i class="pi pi-check text-green-400 ml-2" ></i></p>
                        </div>
                    </div>
                </div>
                <div  *ngIf="message.ownerId === defaultUserId">
                    <div>
                        <div class="flex" style="width:100%; justify-content: right;">
                            <!-- <p-avatar icon="pi pi-user" class="mr-3" shape="circle"  [style]="{borderRadius:'50px'}"></p-avatar> -->
                            <p-avatar icon="pi pi-user" class="mr-3" shape="circle" size="large"  *ngIf="!myUser?.profilePhoto"></p-avatar>
                            <div class="flex" style="align-items: center; border-radius: 40px; justify-content: center; width: 3rem; height: 3rem; overflow: hidden; margin-right: 1rem;" shape="circle" size="large" *ngIf="myUser?.profilePhoto">
                                <img [src]="userPicture"  alt="Foto de Perfil" style="max-height: 100%;"   >
                            </div>
                        </div>
                        <div class="grid grid-nogutter mb-4">
                            <div class="col mt-3 text-right">
                                <span class="inline-block text-left font-medium border-1 surface-border bg-primary-100 text-primary-900 p-3 white-space-normal border-round" style="word-break: break-word; max-width:80%;"  [ngClass]="{'tema-light': tema === 'light', 'tema-dark': tema !== 'light'}">{{message.text}}</span>
                                <p class="text-700 mt-3">{{parseDate(message.createdAt)}} <i class="pi pi-check text-green-400 mr-3" ></i></p>
                            </div>
                        </div>
                    </div>
                </div>


                <div *ngIf="loadingResponse && last">
                    <img src="assets/logotipo.png" alt="user.name" style="width: 20px;">
                    <div style="height: 10px; margin-left: 1em; margin-top: -1em;">
                        <ng-lottie [options]="animationLoader" width="4em" height="4em"></ng-lottie>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-3   flex flex-column sm:flex-row align-items-center mt-auto border-top-1 surface-border "
        [ariaDisabled]="modeSelected===3 || loadingResponse" >
            <div class="flex w-full sm:w-auto gap-3">
                <button pRipple class="p-button p-button-secondary  sm:w-auto justify-content-center text-xl p-button-outlined p-button-rounded"  style ="border:none;margin-right: 0;" (click)="op.toggle($event)"
                [disabled]="modeSelected===3 || loadingResponse"
                >😀</button>
            </div>
            <input id="message" type="text" pInputText placeholder="Type a message" class="flex-1 w-full sm:w-auto border-round" [(ngModel)]="textContent" (keydown.enter)="sendMessage()"
            [disabled]="modeSelected===3 || loadingResponse"
            />
            <button pButton pRipple  type="button" icon="pi pi-send" class="p-button-outlined p-button-rounded" (click)="sendMessage()" style="border: none;"
            [disabled]="modeSelected===3 || loadingResponse"
            ></button>
        </div>
    </div>

    <p-overlayPanel #op styleClass="w-full sm:w-30rem">
        <ng-template pTemplate>
            <button *ngFor="let emoji of emojis;" pButton pRipple (click)="op.hide(); onEmojiSelect(emoji)" type="button" [label]="emoji" class="p-2 p-button-text text-2xl"></button>
        </ng-template>
    </p-overlayPanel>
    </div>
